/**
 * Information Post module — scroll reveal (fade-up) bằng IntersectionObserver, không dùng scroll event.
 * Markup: extension/opencart/catalog/view/template/module/information_post.twig
 *
 * - Chỉ thêm class .ip-js lên <html> khi trình duyệt hỗ trợ IntersectionObserver và người dùng KHÔNG
 *   bật "giảm chuyển động" → CSS chỉ ẩn nội dung khi có .ip-js; còn lại nội dung luôn hiện sẵn
 *   (tắt JS, JS lỗi, trình duyệt cũ, reduced motion, bot đều thấy đủ nội dung từ HTML server).
 * - Mỗi khối chỉ chạy 1 lần: unobserve ngay khi hiện, disconnect khi hết → không rò bộ nhớ.
 * - Nhiều khối vào khung nhìn cùng lúc sẽ hiện lần lượt theo thứ tự DOM (stagger).
 */
(function () {
    'use strict';

    var STAGGER = 120;   // ms giữa các khối cùng vào khung nhìn
    var THRESHOLD = 0.15;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion || !('IntersectionObserver' in window)) {
        return;
    }

    document.documentElement.classList.add('ip-js');

    function byDomOrder(a, b) {
        return (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) ? -1 : 1;
    }

    function init() {
        var items = document.querySelectorAll('.information-post .information-post__reveal:not(.is-revealed)');
        var pending = items.length;

        if (!pending) {
            return;
        }

        var observer = new IntersectionObserver(function (entries) {
            entries
                .filter(function (entry) { return entry.isIntersecting; })
                .map(function (entry) { return entry.target; })
                .sort(byDomOrder)
                .forEach(function (el, index) {
                    el.style.setProperty('--ip-delay', (index * STAGGER) + 'ms');
                    el.classList.add('is-revealed');
                    observer.unobserve(el);
                    pending--;
                });

            if (pending <= 0) {
                observer.disconnect();
            }
        }, {
            rootMargin: '0px 0px -5% 0px',
            threshold: THRESHOLD
        });

        Array.prototype.forEach.call(items, function (el) {
            observer.observe(el);
        });
    }

    // Chờ preloader mở màn (qh:page-reveal, xem main.js) để khối above-the-fold không chạy
    // hiệu ứng xong trong lúc còn bị che.
    if (typeof window.qhOnPageReveal === 'function') {
        window.qhOnPageReveal(init);
    } else if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
